import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { filterRequest } from "../../utilities/apiManager";
import axiosInstance from "../../utilities/axiosInstance";

let initialState = {
  isLoading: false,
  data: [],
  itemsCount: 0,
  pages: 0,
  error: null,
}

export const getInvoices = createAsyncThunk(
  "invoices/getInvoices",
  async (args, thunkApi) => {
    try {
      const { page, size = 10, query = "", owner, user, rent, filter = {} } = args;

      // Clean filter object - only include non-empty values
      const cleanFilter = {};
      Object.keys(filter).forEach(key => {
        const value = filter[key];
        if (value !== null && value !== undefined && value !== "") {
          cleanFilter[key] = value;
        }
      });

      const filterStr = filterRequest(cleanFilter);
      let url = `/invoices?page=${page}&size=${size}`;
      if (query) url += `&search=${query}`;
      if (owner) url += `&owner=${owner}`;
      if (user) url += `&user=${user}`;
      if (rent) url += `&rent=${rent}`;

      url += filterStr;

      const { data } = await axiosInstance.get(url);
      return thunkApi.fulfillWithValue(data);
    } catch (errors) {
      console.log(errors);
      return thunkApi.rejectWithValue(errors.response.data);
    }
  }
);

export const getInvoiceExtends = createAsyncThunk(
  "invoices/getInvoiceExtends",
  async (args, thunkApi) => {
    try {
      const { page, size = 10, query = "", owner, user, filter = {} } = args;

      // Clean filter object - only include non-empty values
      const cleanFilter = {};
      Object.keys(filter).forEach(key => {
        const value = filter[key];
        if (value !== null && value !== undefined && value !== "") {
          cleanFilter[key] = value;
        }
      });

      const filterStr = filterRequest(cleanFilter);
      let url = `/invoices/extends?page=${page}&size=${size}`;
      if (query) url += `&query=${query}`;
      if (owner) url += `&owner=${owner}`;
      if (user) url += `&user=${user}`;
      url += filterStr;

      const { data } = await axiosInstance.get(url);
      return thunkApi.fulfillWithValue(data);
    } catch (errors) {
      console.log(errors);
      return thunkApi.rejectWithValue(errors.response.data);
    }
  }
);

export const payInvoice = createAsyncThunk(
  "invoices/payInvoice",
  async (args, thunkApi) => {
    try {
      const { data } = await axiosInstance.post(
        `/invoices/pay/${args.invoiceId}`,
        {}
      );
      return thunkApi.fulfillWithValue(data);
    } catch (errors) {
      console.log(errors);
      return thunkApi.rejectWithValue(errors.response.data);
    }
  }
);

const invoicesSlice = createSlice({
  name: "invoices",
  initialState,
  reducers: {
    resetInvoices: (state) => {
      state.isLoading = false;
      state.data = [];
      state.itemsCount = 0;
      state.pages = 0;
      state.error = null;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(getInvoices.pending, (state) => {
        state.isLoading = true;
        state.error = null
      })
      .addCase(getInvoices.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        state.error = null;
        // Handle both possible API response structures
        state.data = payload.data?.data || payload.data || [];
        state.itemsCount = payload.data?.itemsCount || payload.itemsCount || 0;
        state.pages = payload.data?.pages || payload.pages || 0;
      })
      .addCase(getInvoices.rejected, (state, { payload }) => {
        state.isLoading = false;
        state.error = payload?.message;
      })

      .addCase(getInvoiceExtends.pending, (state) => {
        state.isLoading = true;
        state.error = null
      })
      .addCase(getInvoiceExtends.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        state.error = null;
        state.data = payload.data?.data || payload.data || [];
        state.itemsCount = payload.data?.itemsCount || payload.itemsCount || 0;
        state.pages = payload.data?.pages || payload.pages || 0;
      })
      .addCase(getInvoiceExtends.rejected, (state, { payload }) => {
        state.isLoading = false;
        state.error = payload?.message;
      })

      .addCase(payInvoice.pending, (state) => {
        state.isLoading = true;
        state.error = null
      })
      .addCase(payInvoice.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        state.error = null;
      })
      .addCase(payInvoice.rejected, (state, { payload }) => {
        state.isLoading = false;
        state.error = payload?.message;
      })
  }
});

export const { resetInvoices } = invoicesSlice.actions;
export default invoicesSlice.reducer;